







import { Component, Vue, Prop } from 'vue-property-decorator';
import ProjectVersions from "@/components/ProjectVersions.vue";
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'Versions',
    components: {
        ProjectVersions,
        NotLoggedPanel
    }
})
export default class Versions extends Vue {
    @Prop() private user!: User;
}
